import { createVisualDiff } from './createVisualDiff';
import { extractVisualDiffInRange } from './extractVisualDiffInRange';
import type { VisualDiffSegment } from './types';
import type { DiffSegment } from '../layered-diffs/types';

/**
 * Creates a visual diff and extracts only the portion within range markers.
 *
 * This is a convenience function that combines:
 * 1. `createVisualDiff` - computes the visual diff with attribution
 * 2. `extractVisualDiffInRange` - extracts only content between RANGE_START and RANGE_END
 *
 * The finalText must contain RANGE_START and RANGE_END markers to define the
 * extraction boundaries.
 *
 * @param existingDiff - The original diff with insert/delete/equal operations
 * @param finalText - The target text containing RANGE_START and RANGE_END markers
 * @returns Visual diff containing only segments within the range, with attribution flags
 */
export function createVisualDiffInRange(
  existingDiff: DiffSegment[],
  finalText: string
): VisualDiffSegment[] {
  const visualDiff = createVisualDiff(existingDiff, finalText);
  return extractVisualDiffInRange(visualDiff);
}
